var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSidemenuToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.874,
    height: 11.747,
    viewBox: "0 0 14.874 11.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sidemenu_toggle",
    transform: "translate(-215.356 -114.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48838",
    "data-name": "Path 48838",
    d: "M12,12l4.46,4.46L12,20.919",
    transform: "translate(212.771 103.541)",
    fill: "none",
    stroke: "#16173b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48839",
    "data-name": "Path 48839",
    d: "M12,12l4.46,4.46L12,20.919",
    transform: "translate(204.771 103.541)",
    fill: "none",
    stroke: "#16173b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidemenuToggle);
export default __webpack_public_path__ + "static/media/ic_sidemenu_toggle.f2546c92e1b9a5f80a44e101dd46a8e4.svg";
export { ForwardRef as ReactComponent };